import * as APIUtil from 'utils/api/categories.api';
import { ChunkedRequestError } from 'utils/api/meta.api';

const fetchTopKeywords = ({ data, paginateBy, controller = null }) =>
    APIUtil.fetchDataPoints({
        data: { has: ['keyword'], ...data },
        paginateBy,
        controller,
    })
        .then(({ results, errors }) => {
            if (errors) throw new ChunkedRequestError(errors);
            return results;
        })
        .catch((err) => {
            console.error(err);
            return Promise.reject(err);
        });

export default fetchTopKeywords;
